/**
 * What a sale's own schedule says about whether it has started.
 *
 * `startAt: null` means RUNNING NOW, not "unscheduled". seedSales writes null
 * for a lane that starts the moment it is created, and the runtime starts every
 * event the instant startEvent is called — so a missing start is the most
 * definite answer the document has, not the absence of one.
 *
 * That distinction is easy to get wrong in the obvious direction: filtering a
 * lane's starts with `.filter(Boolean)` before asking for the earliest one
 * discards exactly the sales that are running, and a house holding three live
 * lanes then reports that it has nothing scheduled.
 *
 * This is the FALLBACK answer. The runtime's is better — a lane is live when it
 * holds a lot that is running — and every caller prefers it when the runtime
 * has said anything. Keeping both is the point: an outage should cost the live
 * chips, not the list of sales.
 */
export const isUnderway = (startAt, now = new Date()) => {
    if (!startAt) return true;
    const started = new Date(startAt).getTime();
    return Number.isNaN(started) ? true : started <= now.getTime();
};

export default isUnderway;
